import {DomainAncestor, entityConfig, fieldInfo} from "../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../core/metamodel/metaConstant";
import {LovItem} from "../../core/metamodel/mdEntity";

@entityConfig()
export class EntityNumberGen extends DomainAncestor {

  @observable entityNumberGenId: ID;

  @observable group: LovItem;

  @observable validFrom: string | Date;
  @observable validTo: string | Date;

  @observable prefixConstant: string;
  @observable padding: number;

  constructor(json: any) {
    super(json);
  }

  getId(): ID {
    return this.entityNumberGenId;
  }

  setId(id: ID) {
    this.entityNumberGenId = <any>id;
  }

  getNumberLength(): number {
    return this.prefixConstant.length + this.padding;
  }
}

@entityConfig()
export class EntityNumberGenGroup extends DomainAncestor {

  @observable entityNumberGenGroupId: ID;
  @observable name: string;

  @observable entityName: string;
  @observable party: LovItem;
  @observable invoiceTypeIds: LovItem[];
  @observable profitCenterIds: LovItem[];

  @observable @fieldInfo(EntityNumberGen) numberGenList: EntityNumberGen[];

  constructor(json: any) {
    super(json);

    if (!this.numberGenList) this.numberGenList = [];
    if (!this.invoiceTypeIds) this.invoiceTypeIds = [];
    if (!this.profitCenterIds) this.profitCenterIds = [];
  }
}



// WEBPACK FOOTER //
// ./src/invoice/domain/entityNumberGenDomain.ts